var map = {
	"./stage1.svg": 327,
	"./stage10.svg": 328,
	"./stage11.svg": 329,
	"./stage12.svg": 330,
	"./stage13.svg": 331,
	"./stage2.svg": 332,
	"./stage3.svg": 333,
	"./stage4.svg": 334,
	"./stage5.svg": 335,
	"./stage6.svg": 336,
	"./stage7.svg": 337,
	"./stage8.svg": 338,
	"./stage9.svg": 339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 326;